import { Client } from "@microsoft/microsoft-graph-client";
import { User } from "@microsoft/microsoft-graph-types";
import { tokenProviderFactory } from "./tokenProvider";

let client: Client | undefined = undefined;

const ensureClient = () => {
  if (!client) {
    client = Client.initWithMiddleware({
      authProvider: tokenProviderFactory(["user.read"]),
    });
  }

  return client;
};

const getUser = async (): Promise<User> => {
  ensureClient();

  // Return the /me API endpoint result as a User object
  const user: User = await client!
    .api("/me")
    // Only retrieve the specific fields needed
    .select("displayName,mail")
    .get();

  return user;
};

const graphClient = {
  getUser,
};

export default graphClient;
